import { Map } from "immutable";

type RefreshOutgoingPaymentDataOptions = {
  getOutgoing: (data?: any) => Promise<unknown>;
  paymentItemsCount: number;
  packingItemsCount?: number;
};

export const refreshOutgoingPaymentData = ({
  getOutgoing,
  paymentItemsCount,
  packingItemsCount,
}: RefreshOutgoingPaymentDataOptions) => {
  const requests = [
    getOutgoing(
      Map({
        type: "waiting_for_payment",
        params: { page: 1, per_page: paymentItemsCount + 1 },
      }),
    ),
    getOutgoing(
      Map({
        type: "paid",
        params: { page: 1, per_page: 0 },
      }),
    ),
  ];

  if (packingItemsCount !== undefined) {
    requests.push(
      getOutgoing(
        Map({
          type: "packing_in_progress",
          params: { page: 1, per_page: packingItemsCount },
        }),
      ),
    );
  }

  return Promise.all(requests);
};
